<!-- <mat-card> -->
<mat-card-content class="div-style-justify">
  <mat-card-title class="header-4-center">About US</mat-card-title>

<nav class ="header-2 ">
	<ul>
	    <li class="div-style-padding"> We are providing a plateform to find out skilled professional. 
			You can define your set of queations, and sytem will interact with candidates with those question set.
			This will help to reduce the time spent on to justify the candidates who are likely to be for you or not. 
		</li>	
	    <li class="div-style-padding">
			We are new emerging company who has looked the market and found the best solution for the customers. 
			We provide a plateform for screening the skilled professionals whome companies are looking for but spends a lot of time on them.
			Instituations can also use this plateform to make the regular test for there Students.
		</li>
  	</ul>
</nav>   


<nav class ="header-2">
	<ul>
	    <li class="div-style-padding">You are granted to use free service without any prior intimation to us. We are not binded with any law to preserve the data entered while using the Service. We are also not responsible for any data issue or any Service problem. Where we are always keen to know the problem and solve them as soon as possible to use hassle free Service.</li>	
	    <li class="div-style-padding">You may require to enter some personal detail if you are using this service. We are responsible to store your data confidential, but not bound by any law in case of any unauthorized collection.</li>
	    <li class="div-style-padding">You are allowed to use the Service. But by any means not allowed to sell or contract the service. In case of found in any such involvement, you will be penalized as per the Indian low of court</li>
		<li class="div-style-padding">We have sole discretion to modify or revise any/all of the Terms and Condition without any prior notice, and you are bound to accept the revised policy</li>
		<li class="div-style-padding">You will only be responsible for any kind of activity happening to your account, irrespective of it is used by you or your employee or any of your subordinates or even any of third party</li>
		<li class="div-style-padding">We always tries to make your data safe and secure. To accomplish this we are authorized/granted from you to take the backup, transit it to other place and store it without any prior information. This will make your data available always and prevent to data loss in case any miss fortune.</li>	    
  	</ul>
</nav>  

</mat-card-content>
<!--  </mat-card> -->